<template>
  <el-image
    :style="{ width: this.width, height: this.height, verticalAlign: 'middle' }"
    fit="cover"
    :src="src"
    :preview-src-list="_previewSrcList"
    :z-index="6000"
  >
    <div class="img-error-container" slot="error">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '40px'
    },
    height: {
      type: String,
      default: '40px'
    },
    previewSrcList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    _previewSrcList() {
      if (this.previewSrcList && this.previewSrcList.length > 0) {
        return this.previewSrcList
      }
      return [this.src]
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.img-error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
</style>
